import * as CheckboxComponents from '@radix-ui/react-checkbox'
import { useState, forwardRef } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'
import IconUse from '_/ui/icons/use'

const WrapperStyles = tv({
	base: 'flex items-center space-x-2 group cursor-pointer',
})

const CheckboxStyles = tv({
	base: 'h-4 w-4 rounded border-2 flex items-center justify-center outline-none appearance-none border-gray-700 group-hover:shadow-[0px_0px_0px_2px_rgba(71,79,234,0.15)] group-hover:bg-primary-neutral/20 group-hover:border-primary-neutral data-[state=checked]:bg-primary-neutral data-[state=checked]:border-primary-neutral text-white group-hover:text-primary-neutral',
})

const labelStyles = tv({
	base: 'pointer-events-all cursor-pointer',
})

interface CheckboxProps extends VariantProps<typeof CheckboxStyles> {
	id?: string
	name: string
	className?: string
	classNameCheckbox?: string
	classNameCheck?: string
	label?: string
	defaultValue?: boolean
	required?: boolean
	checked?: boolean
	type?: 'checkbox' | 'radio'
	onInputChange?: (inputName: string, newValue: any) => void
	onCheckedChange?: (checked: boolean) => void
	hasCheckbox?: boolean
	registerDivRef?: (name: string, element: HTMLDivElement | null, accordion: string) => void
}

export const Checkbox = forwardRef<HTMLDivElement, CheckboxProps>(
	(
		{
			id,
			name,
			className,
			classNameCheckbox,
			label,
			defaultValue,
			required,
			onInputChange,
			onCheckedChange,
			checked,
			registerDivRef,
			hasCheckbox = true,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		},
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		_ref,
	) => {
		const [inputChecked, setInputChecked] = useState(defaultValue || false)

		const handleInputCheck = () => {
			setInputChecked(!inputChecked)
			if (onInputChange) {
				onInputChange(name, !inputChecked)
			}
		}

		return (
			<div
				className={WrapperStyles()}
				data-name='here'
				onChange={handleInputCheck}
				ref={el => registerDivRef?.(name, el, 'rooms')}
			>
				{hasCheckbox && (
					<CheckboxComponents.Root
						id={id ? id : name}
						name={name}
						className={CheckboxStyles({ class: classNameCheckbox })}
						required={required}
						onCheckedChange={onCheckedChange}
						checked={checked}
						defaultChecked={defaultValue}
					>
						<CheckboxComponents.Indicator id={id ? id : name}>
							<IconUse id='check' width={10} height={8} fill='none' />
						</CheckboxComponents.Indicator>
					</CheckboxComponents.Root>
				)}
				<label htmlFor={id ? id : name} className={labelStyles({ class: className })}>
					{label}
				</label>
			</div>
		)
	},
)

Checkbox.displayName = 'Checkbox'
